import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenAlt } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { SkewBox } from "../../components/page/skew";
import { GlobalMedicNav } from "../../components/global-medic/global-medic-nav";

export const GlobalBloPost = () => {

    const navigateTo = useNavigate();

    return (
        <div className="global-medic-container">
            <SkewBox
                title={"BLOG POSTS"}
                background={"/media/global-medic.png"}
            />
            <GlobalMedicNav active={'blog'} />
            <div className="flx-rw e-jt c-al mrg-i-3">
                <button
                    className="add-button gl-btn"
                    onClick={() => navigateTo("/globalmedic/createblog")}
                >
                    <FontAwesomeIcon icon={faPenAlt} color='#2a88cb' className='add-ico' />
                    <span className='st-cap'>Write an article</span>

                </button>
            </div>

        </div>
    );
}